// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__zV4wU","title":"styles_title__Py6cS","content":"styles_content__qOjAv","footer":"styles_footer__wYs-O","closeIcon":"styles_closeIcon__13Wtg"};